import { getConfigBrandCode } from 'src/utils/configUtil/configUtil';

// 주어진 basePath를 기반으로 리다이렉트 URL을 생성하는 함수
// @param basePath - 리다이렉트 기본 경로 (기본값: '/')
export function makeRedirectUrl(basePath: string = '/') {
  // 현재 페이지의 경로와 쿼리 문자열을 결합
  const currentPath = window.location.pathname + window.location.search;

  // 기본 제외 경로 설정 (리다이렉트 파라미터 없이 처리할 경로)
  let excludedPaths = ['/', '/login'];

  // 스테이지/운영 환경에서 멀티테넌시를 고려한 고객사 코드 처리
  let companyCode = '';

  companyCode = getConfigBrandCode() ?? ''; // 고객사 코드 가져오기
  if (companyCode) {
    // basePath를 고객사 코드로 동적 설정 (예: /anchor)
    basePath = `/${companyCode}`;
    // 멀티테넌시를 반영한 제외 경로 동적 생성 (예: /anchor, /anchor/login)
    excludedPaths = [`/${companyCode}`, `/${companyCode}/login`];
  } else {
    // 고객사 코드가 없으면 경고 로그 출력 및 기본 경로 유지
    console.warn('Brand code not found, falling back to /');
  }

  // 디버깅 로그: basePath, 현재 경로, 제외 경로 출력
  console.group('Make Redirect Url Log Group');
  console.log('useRedirectUrl: basePath = ', basePath);
  console.log('useRedirectUrl: currentPath = ', currentPath);
  console.log('useRedirectUrl: excludedPaths = ', excludedPaths);
  console.groupEnd();

  // 현재 경로가 제외 경로에 포함되면 redirectPath 없이 linkType만 추가
  if (excludedPaths.includes(window.location.pathname)) {
    console.log('useRedirectUrl: Excluded path matched, returning basePath with linkType');
    return `${basePath}?linkType=INTERNAL_LINK`;
  }

  // 제외 경로가 아니면 redirectPath와 linkType을 포함한 URL 생성
  console.log('useRedirectUrl: Non-excluded path, adding redirectPath');
  const encodedRedirect = encodeURIComponent(currentPath); // 현재 경로 인코딩
  return `${basePath}?redirectPath=${encodedRedirect}&linkType=INTERNAL_LINK`;
}
